<script lang="ts">
	export let classes: String;
	export let speed: String;
	export { classes as class };
</script>

<div class="marquee flex items-center overflow-hidden {classes}" style="--speed: {speed}">
	<slot />
</div>

<style>
	.marquee {
		width: max-content;
		animation: scroll var(--speed) linear infinite;
	}
	@keyframes scroll {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-50%);
		}
	}
</style>
